import React, { useState, useContext, useEffect } from "react";
import Sidebar from "components/Content/Sidebar/Sidebar";
import Topbar from "components/Content/Topbar/Topbar";
import Footer from "components/Content/Footer/Footer";
import SidebarStyles from "components/Content/Sidebar/Sidebar.module.css";
import { SidebarData } from "./SidebarData"
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

export default function Layout(props) {
  const { userInfo } = useContext(PrivateRoutesContext);

  const [sidebarData, setSidebarData] = useState([]);

  const toggleClass = () => {
    setActive(!isActive);
  };
  const [isActive, setActive] = useState(false);
  const [title, setTitle] = useState("");

  const changeTitle = (newTitle) => {
    setTitle(newTitle);
  }

  useEffect(() => {
    setSidebarData(SidebarData.getItems(userInfo));
  }, [userInfo]);

  return (
    <>
      <Sidebar
        toggleHandler={toggleClass}
        changeTitle={changeTitle}
        siderbarClosed={isActive}
        sidebarToggleIcon={isActive}
        logoToggle={isActive}
        rightPanelWidth={isActive}
        data={sidebarData}
      />
      <div
        className={`${SidebarStyles.rightPanel} ${
          !isActive ? SidebarStyles.closedRightPanel : ""
        }`}
      >
        <Topbar title={title}/>
        <main>
          <div className="content-wrapper">
            {props.children}
          </div>
          <Footer />
        </main>
      </div>
    </>
  );
}
